import React from 'react';
import { useAuth } from '../context/AuthContext';
import MergedPage from '../components/nav/MergedPage';
import Home from './Home';
import WorkerDashboard from './WorkerDashboard';
import Dashboard from './Dashboard';

// Home (Sep 2026 nav restructure): "My Day" + "Company" in one place.
// My Day = the existing clock-in page (Home for managers, WorkerDashboard for
// workers); Company = the existing Dashboard. Admins land on Company.
export default function HomePage() {
  const { user } = useAuth();
  const role = user?.role || 'user';
  const isManager = role === 'admin' || role === 'supervisor' || !!user?.is_super_user;
  const tabs = [
    { key: 'myday', label: 'My Day', render: () => (role === 'user' ? <WorkerDashboard /> : <Home />) },
    ...(isManager ? [{ key: 'company', label: 'Company', render: () => <Dashboard /> }] : []),
  ];
  const defaultTab = role === 'admin' || user?.is_super_user ? 'company' : 'myday';
  return <MergedPage tabs={tabs} defaultTab={defaultTab} testId="home-page" />;
}
